import SlimSelect from 'slim-select';

document.addEventListener('DOMContentLoaded', function () {
  initSlimSelects();
});

const whitespaceRegex = /^\s+/g;

const defaultSettings = {
  placeholderText: 'Seleziona',
  searchText: 'Nessun risultato trovato',
  searchingText: 'Ricerca in corso...',
  searchPlaceholder: 'Cerca...',
  hideSelected: false,
  maxValuesShown: 50,
};

function _initSlimSelect(element) {

  if (element.slim) {
	element.slim.destroy();
  }

  let settings = JSON.parse(element.dataset.slimselect);

  let events = {};

  if (settings.tags) {
	events.addable = function (value) {
	  if (value.match(whitespaceRegex)) {
		return false
	  }

	  return {
		text: value,
		value: value
	  };
	}
  }




  if (settings.ajax?.url) {
	let timeoutId;
	events.search = function (search, currentData) {
	  return new Promise((resolve, reject) => {
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => {
		  if (search.length < 2) {
			return reject('Inserisci almeno 2 caratteri');
		  }

		  let url = `${settings.ajax.url}&query=${search}`;
		  fetch(url)
			.then(response => { return response.json(); })
			.then(data => {
			  return resolve(data)
			});
		}, settings.ajax.delay);
	  });
	}
  }

  settings = {
	...defaultSettings,
	...settings
  };

  let ss = new SlimSelect({
	select: element,
	settings: settings,
	events: events
  });

  if (settings.selectAll) {
	ss.events.beforeOpen = function () {
	  var data = ss.getData();
	  data.forEach(function (item) {
		if (item.selectAll === false) {
		  item.selectAll = true;
		  item.selectAllText = settings.selectAll
		}
	  });
	  ss.setData(data);
	};
  }

  return ss;
}

export function initSlimSelects() {
  const commonSelects = document.querySelectorAll('[data-slimselect]');
  commonSelects.forEach((element) => {
	_initSlimSelect(element);
  })
}

export function initSlimSelect(elementSelector, selectedValue = '') {
  let element = document.querySelector(elementSelector);

  let ss = _initSlimSelect(element);

  if (selectedValue) {
	ss.setSelected(selectedValue);
  }
}

